module.exports = __webpack_public_path__ + "static/media/add1.5db6fdb2.svg";